import { render, staticRenderFns } from "./ChipGroup.vue?vue&type=template&id=fb17a378"
import script from "./ChipGroup.vue?vue&type=script&lang=js"
export * from "./ChipGroup.vue?vue&type=script&lang=js"
import style0 from "./ChipGroup.vue?vue&type=style&index=0&id=fb17a378&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports